// Page module: creating a match by hand (matches#new).

global.customMatch = {
    sl: {
      "format": "DD.MM.YYYY, HH:mm",
      "separator": " - ",
      "firstDay": 1
    },
    data: {},
    init: function(saveUrl) {
      customMatch.data.saveUrl = saveUrl;

      context = {
        json: function() {
          return JSON.stringify(this);
        },
        formatted_match_time: function() {
          return this.match_time_d ? this.match_time_d.format(customMatch.sl.format) : '';
        }
      };
      
      customMatch.initTimePicker();
    },
    initTimePicker: function() {
      var $item = $('.single-date-picker');
      var matchtime;
      var matchtimed = $item.data('matchtimed');
      if(matchtimed) {
        context.match_time_d = moment(matchtimed);
        context.date_time = context.match_time_d.format();
        matchtime = context.formatted_match_time();
        refreshContext();
      }
      $item.daterangepicker({
        locale: customMatch.sl,
        autoUpdateInput: !!matchtime,
        startDate: matchtime,
        timePicker: true,
        timePicker24Hour: true,
        timePickerSeconds: false,
        singleDatePicker: true
      });
      $item.on('apply.daterangepicker', function (ev, picker) {
        context.match_time_d = picker.startDate;
        context.date_time = context.match_time_d.format();
        refreshContext();
      });
    }
}
